import createInterceptor from './Interceptor';
import apiUrls from '@/config/apiUrls';

const baseURL = apiUrls.DASHBOARD_MGR_JWT_URL;

const axiosInstance = createInterceptor({
  baseURL,
  withCredentials: true,
});

export default axiosInstance;
